<template>
  <section id="what" class="section what-section">
    <div class="what-inner">
      <div class="image-box">
        <img :src="require('@/assets/woman-laptop@2x.png')" alt="NBCFA" class="section-img" />
      </div>
      <div class="text">
        <h2 v-html="$t('whatIs.title').replace('\n', '<br>')"></h2>
        <div class="title-line" :class="{ 'title-line-en': $i18n.locale === 'en' }"></div>

        <p>{{ $t('whatIs.p1') }}</p>
        <p>{{ $t('whatIs.p2') }}</p>
        <p>{{ $t('whatIs.p3') }}</p>
        <button class="btn-view" @click="$router.push('/about')">{{ $t('whatIs.viewMore') }} <img src="../assets/arrow-white@2x.png" style="width: 20px; height: auto;"></button>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'WhatIsCepa' }
</script>

<style scoped>
.what-section { padding: 80px 40px; background: #fff; }
.what-inner { max-width: 1100px; margin: 0 auto; display: flex; align-items: center; gap: 60px; }
.image-box {
  flex-shrink: 0; width: 320px; height: 380px;
  border-radius: 12px; overflow: hidden;
}
.title-line { width: 300px; height: 10px; background: linear-gradient(to right, #2b7de9, transparent); margin: -18px 0px 40px; }
.title-line-en { width: 400px; height: 10px; background: linear-gradient(to right, #2b7de9, transparent); margin: -25px 0px 40px; }
.section-img {
  width: 100%; height: 100%;
}
.text { flex: 1; }
h2 { font-size: 26px; font-weight: 700; color: #1a1a1a; line-height: 1.4; margin-bottom: 12px; }
.divider { width: 48px; height: 3px; background: #2b7de9; margin-bottom: 20px; }
p { font-size: 14px; color: #555; line-height: 1.8; margin-bottom: 12px; }
.btn-view {
  display: inline-block; background: #2b7de9; color: #fff; border: none; padding: 10px 24px;
  border-radius: 4px; font-size: 13px; font-weight: 600; cursor: pointer; margin-top: 8px; transition: background 0.2s;
}
.btn-view:hover { background: #1a6ad4; }

.btn-start {
  background: #2b7de9; color: #fff; border: none; padding: 12px 32px;
  border-radius: 6px; font-size: 15px; font-weight: 600; cursor: pointer; transition: background 0.2s;
}
.btn-start:hover { background: #1a6ad4; }
@media (max-width: 768px) {
  .what-inner { flex-direction: column; }
  .image-box { width: 100%; height: 200px; }
}
</style>
